import { render, staticRenderFns } from "./invoice-preview.vue?vue&type=template&id=12e1d86a&scoped=true&"
import script from "./invoice-preview.ts?vue&type=script&lang=js&"
export * from "./invoice-preview.ts?vue&type=script&lang=js&"
import style0 from "./invoice-preview.vue?vue&type=style&index=0&id=12e1d86a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12e1d86a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VBtn,VIcon,VSheet,VSpacer,VToolbar})
